import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'


{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../img/logoBlancoSVG2.svg';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesaInspeccion.module.css'; { {/*Estilos para el componente*/ } }
import Backdrop from '@mui/material/Backdrop';

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar, faWrench,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesa from './BotonMenuHamburguesa';
import ConfiguracionComponent from '../UsuarioInspector/Configuracion/ConfiguracionComponent';

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar, faWrench)


const MenuHamburguesaInspeccion = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '36px'
        },
        bmBurgerBars: {
            background: 'white'
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: 'white'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: 'rgb(14, 129, 60)',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: 'white',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const styleModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: 'scroll',
        height: '80%',
    };


    const myRef = useRef(null)
    const currentUser = useSelector(store => store.Usuario.data)
    const id = useSelector(store => store.Usuario.tipoUsuario)
    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }



    const zonasOpciones = [];
    const solicitudesOpciones = [];
    const inspectoresOpciones = [];
    const agendaOpciones = [];
    const calendarioOpciones = [];
    const trazabilidadOpciones = [];
    const asociadosOpciones = [];
    const fisicoquimicoOpciones = [];
    const inventarioOpciones = [];
    const autorizarEtiquetasOpciones = [];
    const catalogoMagueyOpciones = [];
    const vehiculosOpciones = [];
    const generadorInformesOpciones = [

        { text: 'Instalaciones', ruta: '' },
        { text: 'Granel', ruta: '' },
        { text: 'Nacional', ruta: '' },
        { text: 'Exportación', ruta: '' },

    ];
    const generadorEtiquetasOpciones = [

        { text: 'Granel', ruta: '' },
        { text: 'Laboratorio', ruta: '' },
        { text: 'Maduración', ruta: '' },

    ];
    const generarVisitaOpciones = [];

    const [modalConfig, setModalConfig] = React.useState(false);
    const handleAbrirModalConfig = () => {
        setModalConfig(true);
    }

    const handleCerrarModalConfig = () => {
        setModalConfig(false);
    }
    const HTMLabrirConfiguraciones = () => {
        return (
            <Modal
                open={modalConfig}
                onClose={handleCerrarModalConfig}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} >
                    <ConfiguracionComponent handleCerrarModalConfig={handleCerrarModalConfig}></ConfiguracionComponent>
                </Box>

            </Modal>
        )
    }

    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row'>
                        <div className='col-9'>
                            <div className='row'>
                                <div className='col-5'>

                                </div>
                                <div className='col-5 mt-2' style={{ textAlign: 'center' }}>
                                    <span className='textoEscondido text-center text-light' style={{ wordWrap: 'break-word' }}><h5><strong>Panel {id == 9 ? "Consulta UI" : "GERENCIAL"}</strong><br /> <p>COMERCAM en Línea</p></h5></span>
                                </div>
                            </div>

                        </div>
                        <div className='col-3 mt-3'>
                            <Tooltip title="Configuraciones" arrow>
                                <button style={{ border: 'none', marginRight: '30px', backgroundColor: '#0e813c', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} className="text-wrap text-center botonZoom" onClick={handleAbrirModalConfig}> <FontAwesomeIcon style={{ transform: 'scale(1.3)' }} icon={faWrench} /><br />Configurar</button>
                            </Tooltip>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: '#0e813c', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.3)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>
                        </div>
                    </header>
                </Fragment>
            </div>

            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    {
                        props.idUsuario === 5 ?
                            (
                                <Fragment>
                                    <BotonMenuHamburguesa titulo="Calendario" objeto={calendarioOpciones} ruta="/panelCalendario"></BotonMenuHamburguesa>
                                    <BotonMenuHamburguesa titulo="Inspectores" objeto={inspectoresOpciones} ruta="/PanelInspectores"></BotonMenuHamburguesa>
                                    <BotonMenuHamburguesa titulo="Zonas" objeto={zonasOpciones} ruta="/PanelZonas"></BotonMenuHamburguesa>
                                    {/* <BotonMenuHamburguesa titulo="Asociados" objeto={asociadosOpciones} ruta="/PanelAsociados"></BotonMenuHamburguesa> */}
                                    <BotonMenuHamburguesa titulo="Solicitudes" objeto={solicitudesOpciones} ruta="/PanelSolicitudes"></BotonMenuHamburguesa>
                                    <BotonMenuHamburguesa titulo="Vehiculos" objeto={vehiculosOpciones} ruta="/PanelVehiculos"></BotonMenuHamburguesa>
                                    <BotonMenuHamburguesa titulo="Fisico - Quimicos" objeto={fisicoquimicoOpciones} ruta="/panelFisicoQuimicos"></BotonMenuHamburguesa>
                                    <BotonMenuHamburguesa titulo="Trazabilidad" objeto={trazabilidadOpciones} ruta="/panelTrazabilidad"></BotonMenuHamburguesa>
                                </Fragment>
                            ) :
                            props.idUsuario === 4 ?
                                (

                                    <Fragment>
                                        <BotonMenuHamburguesa titulo="Calendario" objeto={calendarioOpciones} ruta="/panelCalendario"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Agenda" objeto={agendaOpciones} ruta="/panelAgenda"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Trazabilidad" objeto={trazabilidadOpciones} ruta="/panelTrazabilidad"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Asociados" objeto={asociadosOpciones} ruta="/panelAsociados"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Fisico - Quimicos" objeto={fisicoquimicoOpciones} ruta="/panelFisicoQuimicos"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Inventario" objeto={inventarioOpciones} ruta="/panelInventario"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Autorizar Etiquetas" objeto={autorizarEtiquetasOpciones} ruta="/panelAutorizarEtiquetas"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Catalogo de Maguey" objeto={catalogoMagueyOpciones} ruta="/panelCatalogoMaguey"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Generador de Informes" objeto={generadorInformesOpciones} ruta="/panelInformes"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Generador de Etiquetas" objeto={generadorEtiquetasOpciones} ruta="/panelEtiquetas"></BotonMenuHamburguesa>
                                        <BotonMenuHamburguesa titulo="Generador de Visita" objeto={generarVisitaOpciones} ruta="/panelVisitas"></BotonMenuHamburguesa>
                                    </Fragment>
                                ) :
                                props.idUsuario === 13 ?
                                    (
                                        <Fragment>
                                            {/* <BotonMenuHamburguesa titulo="Asociados" objeto={asociadosOpciones} ruta="/PanelAsociados"></BotonMenuHamburguesa> */}
                                            <BotonMenuHamburguesa titulo="Solicitudes" objeto={solicitudesOpciones} ruta="/PanelSolicitudes"></BotonMenuHamburguesa>
                                        </Fragment>
                                    ) :
                                    (<></>)
                    }
                </List>
            </Menu>

            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
            {HTMLabrirConfiguraciones()}

        </Fragment >
    );
};
export default withRouter(MenuHamburguesaInspeccion)
